import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Mail, MessageSquare, Briefcase, CheckCircle2 } from 'lucide-react';

const Contact = () => {
  const [form, setForm] = useState({ name: '', email: '', subject: 'general', message: '' });
  const [sent, setSent] = useState(false);

  const submit = (e) => {
    e.preventDefault();
    // Best-effort: open mail client with pre-filled message
    const body = `Name: ${form.name}%0D%0AEmail: ${form.email}%0D%0ASubject: ${form.subject}%0D%0A%0D%0A${encodeURIComponent(form.message)}`;
    window.location.href = `mailto:ponomobiz@gmail.com?subject=BLUNT%20TV%20—%20${encodeURIComponent(form.subject)}&body=${body}`;
    setSent(true);
  };

  return (
    <div className="min-h-screen relative overflow-hidden">
      <div className="absolute inset-0">
        <div className="absolute -top-40 -right-40 w-[560px] h-[560px] rounded-full bg-[#E50914]/10 blur-[160px]" />
      </div>

      <header className="relative z-10 max-w-6xl mx-auto px-6 py-6 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3 text-white/70 hover:text-white"><ArrowLeft size={18} /> Back</Link>
        <div className="flex items-center gap-3">
          <div className="w-9 h-9 rounded-xl bg-[#E50914] flex items-center justify-center">
            <span className="font-display text-xl text-white leading-none">B</span>
          </div>
          <div className="font-display text-xl tracking-wider text-white">BLUNT TV</div>
        </div>
      </header>

      <div className="relative z-10 max-w-5xl mx-auto px-6 py-10 grid md:grid-cols-5 gap-8">
        <div className="md:col-span-2">
          <span className="text-[11px] tracking-widest uppercase text-white/50">Contact</span>
          <h1 className="font-display text-5xl md:text-6xl text-white mt-3">Let&apos;s talk.</h1>
          <p className="text-white/70 mt-4">Questions, feature requests, partnerships, or just want to say hi — we reply to everything.</p>

          <div className="mt-8 space-y-3">
            <a href="mailto:ponomobiz@gmail.com" className="flex items-center gap-3 p-4 rounded-xl bg-white/5 border border-white/10 hover:bg-white/10 transition">
              <div className="w-10 h-10 rounded-lg bg-[#E50914]/15 text-[#E50914] flex items-center justify-center"><Mail size={18} /></div>
              <div>
                <div className="text-white font-medium">Email support</div>
                <div className="text-white/60 text-sm">ponomobiz@gmail.com</div>
              </div>
            </a>
            <div className="flex items-center gap-3 p-4 rounded-xl bg-white/5 border border-white/10">
              <div className="w-10 h-10 rounded-lg bg-[#E50914]/15 text-[#E50914] flex items-center justify-center"><MessageSquare size={18} /></div>
              <div>
                <div className="text-white font-medium">Live chat</div>
                <div className="text-white/60 text-sm">Coming soon</div>
              </div>
            </div>
            <div className="flex items-center gap-3 p-4 rounded-xl bg-white/5 border border-white/10">
              <div className="w-10 h-10 rounded-lg bg-[#E50914]/15 text-[#E50914] flex items-center justify-center"><Briefcase size={18} /></div>
              <div>
                <div className="text-white font-medium">Partnerships</div>
                <div className="text-white/60 text-sm">Filmmakers &amp; distributors welcome</div>
              </div>
            </div>
          </div>
        </div>

        <div className="md:col-span-3">
          <div className="p-8 rounded-2xl bg-white/5 border border-white/10">
            {sent ? (
              <div className="text-center py-8">
                <CheckCircle2 className="mx-auto text-emerald-400" size={48} />
                <h3 className="text-2xl font-semibold mt-4">Message drafted!</h3>
                <p className="text-white/60 mt-2">We opened your email client. Hit send and we’ll get back within 24 hours.</p>
                <button onClick={() => setSent(false)} className="mt-5 px-5 py-2.5 rounded-lg bg-white/10 hover:bg-white/15">Send another</button>
              </div>
            ) : (
              <form onSubmit={submit} className="space-y-4">
                <div className="grid md:grid-cols-2 gap-4">
                  <div>
                    <label className="text-xs text-white/60">Your name</label>
                    <input required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })}
                      className="w-full mt-1 px-3 py-2.5 rounded-lg bg-white/5 border border-white/15 text-white" />
                  </div>
                  <div>
                    <label className="text-xs text-white/60">Email</label>
                    <input required type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })}
                      className="w-full mt-1 px-3 py-2.5 rounded-lg bg-white/5 border border-white/15 text-white" />
                  </div>
                </div>
                <div>
                  <label className="text-xs text-white/60">Topic</label>
                  <select value={form.subject} onChange={(e) => setForm({ ...form, subject: e.target.value })}
                    className="w-full mt-1 px-3 py-2.5 rounded-lg bg-white/5 border border-white/15 text-white">
                    <option value="general">General question</option>
                    <option value="billing">Billing &amp; subscription</option>
                    <option value="bug">Report a bug</option>
                    <option value="partnership">Partnership / publishing</option>
                    <option value="takedown">Content removal request</option>
                  </select>
                </div>
                <div>
                  <label className="text-xs text-white/60">Message</label>
                  <textarea required rows={6} value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })}
                    className="w-full mt-1 px-3 py-2.5 rounded-lg bg-white/5 border border-white/15 text-white" />
                </div>
                <button type="submit" className="w-full py-3 rounded-lg bg-[#E50914] hover:bg-[#f6121d] text-white font-semibold">Send message</button>
                <div className="text-xs text-white/40 text-center">This opens your email client with the message pre-filled.</div>
              </form>
            )}
          </div>
        </div>
      </div>

      <footer className="relative z-10 py-8 text-center text-white/40 text-sm">
        © {new Date().getFullYear()} BLUNT TV • <Link className="hover:text-white" to="/about">About</Link> • <Link className="hover:text-white" to="/terms">Terms</Link> • <Link className="hover:text-white" to="/privacy">Privacy</Link>
      </footer>
    </div>
  );
};

export default Contact;
